import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import displaySettings from './modules/displaySettings';
import common from './modules/common';
import account from './modules/account';
import notifications from './modules/notifications';
import ghlPolling from './modules/ghlPolling';

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: process.env.VUE_APP_VUEX_KEY || 'gcg-store',
  modules: [
    'displaySettings',
    'account',
    'notifications',
  ],
});

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    displaySettings,
    common,
    account,
    notifications,
    ghlPolling,
  },
  strict: debug,
  plugins: [vuexLocal.plugin],
});
